"use strict"

import { getCartCount, getUserEmailAddress, isLoggedIn } from '../utils/cookies';

const CLASSES = {
    HIDDEN: 'u-hidden',
    LOGGED_IN: 'user-logged-in',
    LOGGED_OUT: 'user-logged-out',
    HAS_CART: 'items-in-cart'
}

const SELECTORS = {
    RETURN_URL: '.js-append-returnurl',
    BASKET_COUNT: '.js-cart-icon .cart-number',
    EMAIL_ADDRESS: '.account-menu__item--email .account-menu__email',
}

export function init() {
    if (isLoggedIn()) {
        document.body.classList.add(CLASSES.LOGGED_IN);

        if (document.querySelector(SELECTORS.EMAIL_ADDRESS)) {
            document.querySelector(SELECTORS.EMAIL_ADDRESS).textContent = getUserEmailAddress();
        }
    } else {
        document.body.classList.add(CLASSES.LOGGED_OUT);
    }

    if (getCartCount() > 0) {
        document.body.classList.add(CLASSES.HAS_CART);
        document.querySelector(SELECTORS.BASKET_COUNT).textContent = getCartCount();
    } else {
        document.body.classList.remove(CLASSES.HAS_CART);
    }

    document.querySelectorAll(SELECTORS.RETURN_URL).forEach(el => {
        const url = el.dataset.href || el.getAttribute('href');
        const separator = url.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${url}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}
